import type { Undefinable } from "@core/domain/types/undefinable.type";
import { BaseViewModel } from "@core/presentacion/view-model/base/base.viewmodel";
import type { EntityApiKey } from "@entity-api-keys/domain/models/entity-api-key.model";
import { GetEntityApiKeyByIdUseCase } from "@entity-api-keys/domain/usecases/get-entity-api-key-by-id.usecase";
import { inject, injectable } from "inversify";
import {
    action,
    flow,
    flowResult,
    makeObservable,
    observable,
    runInAction,
} from "mobx";

@injectable()
export class DetailEntityApiKeyPageViewModel extends BaseViewModel {
    apiKeyId: Undefinable<number> = undefined;

    @observable
    initiallyLoading: boolean = true;

    @observable
    apiKey: Undefinable<EntityApiKey> = undefined;

    constructor(
        @inject(GetEntityApiKeyByIdUseCase)
        private readonly getByIdUseCase: GetEntityApiKeyByIdUseCase,
    ) {
        super();
        makeObservable(this);
    }

    override async didMount(): Promise<void> {
        this.initViewData();
    }

    @flow
    async *initViewData(): AsyncGenerator<void> {
        yield flowResult(this.load());
        runInAction(() => {
            this.initiallyLoading = false;
        });
    }

    async load(): Promise<void> {
        if (this.apiKeyId === undefined) throw new Error("Missing apiKeyId");

        const key = await this.getByIdUseCase.execute(this.apiKeyId);
        if (key) {
            this.setApiKey(key);
        }
    }

    @action
    setApiKey(key: EntityApiKey): void {
        this.apiKey = key;
    }
}
